import React, { useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { chain, isEmpty } from 'lodash';
import NoReviews from '../shared/NoReviews';
import LoadMoreBtn from '../shared/LoadMoreBtn';
import { getLastReviewDetails } from '../../utils';
import useObserver from '../shared/hooks/useObserver';
import { reportEvent } from '../../utils/reports/reviewsList';
import FreelancerReviewItem from './FreelancerReviewItem';

const FreelancerReviewsList = ({
    reviews = [],
    gigsData = [],
    hasNext,
    type,
    ignoredReviewIds,
    fetchReviews,
    onLoadMoreClick,
}) => {
    const reviewsListRef = useRef(null);

    const gigsHashMap = useMemo(
        () =>
            chain(gigsData)
                .groupBy('gig_id')
                .mapValues((v) => v[0])
                .value(),
        [gigsData]
    );

    const lastReview = useMemo(() => getLastReviewDetails({ reviews, ignoredReviewIds }), [reviews, ignoredReviewIds]);
    const hasReviews = !isEmpty(reviews);

    useObserver({
        observableRef: reviewsListRef,
        onObserve: () => reportEvent(),
    });

    return (
        <div className="freelancer-reviews-wrap">
            {hasReviews ? (
                <>
                    <ul className="freelancer-reviews-list" ref={reviewsListRef}>
                        {reviews.map((item) => (
                            <FreelancerReviewItem key={item.id} review={item} gigData={gigsHashMap[item.gig_id]} />
                        ))}
                    </ul>
                    {hasNext && (
                        <LoadMoreBtn
                            fetchReviews={fetchReviews}
                            onLoadMoreClick={onLoadMoreClick}
                            type={type}
                            lastReviewDetails={lastReview}
                        />
                    )}
                </>
            ) : (
                <NoReviews />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    reviews: state.reviews,
    gigsData: state.gigsData,
    type: state.type,
    ignoredReviewIds: state.ignored_review_ids,
    hasNext: state.has_next,
});

export default connect(mapStateToProps)(FreelancerReviewsList);
